// src/data/studentMenu.js
export const studentMenu = [
  { id: 1, title: "Student Dashboard", link: "/dashboard/student" },
  // { id: 2, title: "My Lessons", link: "/dashboard/student/lessons" },
  { id: 2, title: "Teachers", link: "/dashboard/student/teachers" },
  { id: 3, title: "Subscriptions", link: "/dashboard/student/subscriptions" },
  { id: 4, title: "Recorded Lessons", link: "/dashboard/student/replays" },
  { id: 5, title: "Upcoming", link: "/dashboard/student/upcoming" },
  // { id: 7, title: "Settings", link: "/dashboard/student/settings" },
  { id: 6, title: "Support", link: "/dashboard/student/support" },
];
// src/data/teacherMenu.js
export const teacherMenu = [
  { id: 1, title: "Teacher Dashboard", link: "/dashboard/teacher" },
  { id: 2, title: "Profile", link: "/dashboard/teacher/profile" },
  {
    id: 3,
    title: "Availability / Schedule",
    link: "/dashboard/teacher/availability",
  },
  {
    id: 4,
    title: "Upcoming",
    link: "/dashboard/teacher/bookings",
  },
  // { id: 5, title: "My Lessons", link: "/dashboard/teacher/lessons" },
  // { id: 5, title: "Recorded Lessons", link: "/dashboard/teacher/replays" },
  // { id: 7, title: "Payments / Earnings", link: "/dashboard/teacher/payments" },
  // { id: 8, title: "Practice", link: "/dashboard/teacher/practice" },
  // { id: 9, title: "Settings", link: "/dashboard/teacher/settings" },
  { id: 5, title: "Support", link: "/dashboard/teacher/support" },
];
export const adminMenu = [
  { id: 1, title: "Overview", link: "/dashboard/admin" },
  { id: 2, title: "Students", link: "/dashboard/admin/students" },
  { id: 3, title: "Teachers", link: "/dashboard/admin/teacher" },
  { id: 4, title: "Subscriptions", link: "/dashboard/admin/users" },
  { id: 5, title: "Queries", link: "/dashboard/admin/queries" },
];
